import Temp from "@/courier/Temp";

export default class SCGFrozen extends Temp {
  static CODE = "SCGF";

  constructor() {
    super(SCGFrozen.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;
    let travel_surcharge = 0

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode))

    from = super.checkZone(Number(item.fromPostcode));
    to = super.checkZone(item.toPostcode);
    if (
      (from == 1 && to == 1) ||
      item.fromPostcode.toString().substring(0, 2) ==
      item.toPostcode.toString().substring(0, 2)
    ) {
      type = 1;
    } else {
      if (from == 1) {
        type = 2;
      } else {
        type = 3;
      }
    }
    // same zone SCG postcode for check fuel surcharge
    const sameZoneSCG =
      super.checkZone(item.fromPostcode, "SCG") ==
      super.checkZone(item.toPostcode, "SCG");

    let fuel_prefix = sameZoneSCG ? "SAME_ZONE_" : "CROSS_ZONE_";
    fuel_surcharge = await super.scgFuelSurcharge(item.parcel.key_size, fuel_prefix)

    if (travel_surcharge && remote_area) {
      travel_surcharge = 0
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      cross_price: cross_price,
      fuel_surcharge: fuel_surcharge,
      fuel_prefix: fuel_prefix
    };
  }

  async checkWeight(courierRates, item) {
    let fuelSurcharge = 0;
    let keySizeNew = null;
    let SCGSize = item.sizeCheckPrice.SCGSize.filter(function (col) {
      return ['Envelop', 'PM', 'PL', '50', '90', '140', '160', '180', '200', '250'].indexOf(col.code) < 0
    })

    keySizeNew = await super.checkSizeKey(item, SCGSize);

    if (keySizeNew != item.keySize) {
      fuelSurcharge = await super.scgFuelSurcharge(keySizeNew, item.fuelPrefix)
    }

    item.keySize = keySizeNew

    item.index = courierRates.findIndex((rate) => {
      return rate.dimension == item.keySize;
    });

    return {
      index: item.index,
      keySize: item.keySize,
      fuelSurcharge: fuelSurcharge
    };
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["SCGF"]).then((res) => {
        let returnRate = {
          isRemote: res.data.SCGF?(res.data.SCGF.is_remote?50:0):0,
          isTravelArea: 0,
          isIsland: 0
        };
        if (!returnRate.isRemote) {
          returnRate.isTravelArea = res.data.SCGF?(res.data.SCGF.is_tourist?50:0):0
        }
        resolve(returnRate);
      });
    });
  }
}
